import {
    SummaryWithFormDefinitionSummaryModel
} from '../../../../form/definition/form/api/entity/SummaryWithFormDefinitionSummary.model';
import {LovValueSummary} from '../../../../common/lov/lov-value/api/model/lovValueSummary.model';

export class ExamenDefinitionSummaryModel extends SummaryWithFormDefinitionSummaryModel {
    id: number;
    types: LovValueSummary[] = [];
}

export const EXAM_FORM_DEFINITION_CONTEXT = 'FORM_CONTEXT_EXAM';

export enum ExamDefinitionType {
    ANALYSE_COURSE= 'EXAM_FORM_TYPE_ANALYSE_COURSE',
    POSTURO_ANAMNESE = 'EXAM_FORM_TYPE_POSTURO_ANAMNESE',
    POSTURO_DYNAMIQUE = 'EXAM_FORM_TYPE_POSTURO_DYNAMIQUE',
    POSTURO_TRAITEMENT   = 'EXAM_FORM_TYPE_POSTURO_TRAITEMENT',
    FEET_PRESSURE = 'EXAM_FORM_TYPE_FEET_PRESSURE',
    REFLEXE_ARCHAIQUE = 'EXAM_FORM_TYPE_REFLEXE_ARCHAIQUE',
    CHAINE_MUSCULAIRE_GDS = 'EXAM_FORM_TYPE_CHAINE_MUSCULAIRE_GDS',
    CHAINE_PREFERENCE_MOTRICE = 'EXAM_FORM_TYPE_CHAINE_PREFERENCE_MOTRICE',
    KINESIOLOGIE = 'EXAM_FORM_TYPE_KINESIOLOGIE',
    PEDICURIE = 'EXAM_FORM_TYPE_PEDICURIE',
    ANALYSE_MARCHE = 'EXAM_FORM_TYPE_ANALYSE_MARCHE',
    BIOMECANIQUE = 'EXAM_FORM_TYPE_BIOMECANIQUE',
    DIABETIQUE = 'EXAM_FORM_TYPE_DIABETIQUE',
    BACK = 'EXAM_FORM_TYPE_BACK',
    PALPATORY = 'EXAM_FORM_TYPE_PALPATORY',
    STATIC = 'EXAM_FORM_TYPE_STATIC',
    STATIC_KINEOD = 'EXAM_FORM_TYPE_STATIC_KINEOD',
    FASCIA = 'EXAM_FORM_TYPE_FASCIA',
    REFLEXES_ARCHAIQUES = 'EXAM_FORM_TYPE_REFLEXES_ARCHAIQUES',
    TESTING = 'EXAM_FORM_TYPE_TESTING',
}
